import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, CONTACT_INFO, TESTIMONIALS } from '../../utils/constants';

const FAQ_ITEMS = [
  {
    question: 'What is ITorama / Pegasus PMS?',
    answer: 'ITorama (powered by Pegasus PMS) is a property management software built for Kenyan landlords. It automates M-Pesa rent collection, sends instant SMS receipts to tenants, tracks expenses, generates accounting reports, and manages digital lease agreements — all from your phone or browser.',
  },
  {
    question: 'Does ITorama integrate with M-Pesa?',
    answer: 'Yes. ITorama has deep M-Pesa integration that automatically reconciles incoming payments to the correct tenant and unit. No more manually checking M-Pesa statements or WhatsApp messages.',
  },
  {
    question: 'Is there a free plan for property management software in Kenya?',
    answer: 'Yes. ITorama offers a free Starter plan that supports up to 5 rental units with M-Pesa reconciliation, tenant SMS receipts, and basic reporting — completely free, no credit card required.',
  },
  {
    question: 'How much does property management software cost in Kenya?',
    answer: 'ITorama starts free (up to 5 units). The Professional plan is KES 3,500/month for up to 20 units and includes full accounting, WhatsApp integration, and digital leases. The Enterprise plan is KES 5,000/month for unlimited units with dedicated support and API access.',
  },
  {
    question: 'Can I manage my rental properties from my phone?',
    answer: 'Yes. ITorama is fully mobile-responsive and works on any smartphone browser. You can collect rent, send receipts, view dashboards, and manage tenants entirely from your phone.',
  },
  {
    question: 'How do tenants pay rent using ITorama?',
    answer: "Tenants pay via M-Pesa using your existing pay bill or till number. ITorama automatically detects the payment, matches it to the correct tenant, and sends them an instant receipt — no manual work required.",
  },
  {
    question: 'Does ITorama send automatic rent reminders?',
    answer: 'Yes. ITorama sends automated rent reminders to tenants via SMS and WhatsApp before and on the due date, significantly reducing late payments.',
  },
  {
    question: 'Can I replace my property agent with ITorama?',
    answer: "Yes. ITorama is designed to replace a traditional property agent for landlords who self-manage. It handles rent collection, receipts, tenant communication, accounting, and lease management — saving Kenyan landlords an average of KES 276,000 per year in agent fees.",
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
};

const reviewSchema = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'ITorama Pegasus PMS',
  description: 'Property Management Software for Kenyan Landlords',
  brand: {
    '@type': 'Brand',
    name: 'ITorama',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5',
    ratingCount: String(TESTIMONIALS.length),
    bestRating: '5',
    worstRating: '1',
  },
  review: TESTIMONIALS.map((t) => ({
    '@type': 'Review',
    author: {
      '@type': 'Person',
      name: t.name,
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: String(t.rating),
      bestRating: '5',
    },
    reviewBody: t.quote,
    name: t.role,
  })),
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: `${SITE_URL}/`,
    },
  ],
};

const StructuredData = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    <script type="application/ld+json">{JSON.stringify(reviewSchema)}</script>
    <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  </Helmet>
);

export { FAQ_ITEMS };
export default StructuredData;
